
(function () {
  document.querySelectorAll('[data-z9-hero-slideshow]').forEach(function (el) {
    var slides = el.querySelectorAll('.z9-hero__slide');
    var dots = el.querySelectorAll('.z9-hero__dot');
    var prevBtn = el.querySelector('.z9-hero__arrow--prev');
    var nextBtn = el.querySelector('.z9-hero__arrow--next');
    var current = 0;
    var total = slides.length;
    var autoplay = parseInt(el.dataset.autoplay) || 0;
    var timer = null;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
      current = index;
    }

    function startAutoplay() {
      if (autoplay > 0 && total > 1) {
        timer = setInterval(function () { goTo(current + 1); }, autoplay);
      }
    }

    function resetAutoplay() {
      clearInterval(timer);
      startAutoplay();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); resetAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); resetAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); resetAutoplay(); });
    });

    
    var touchStartX = 0;
    el.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(diff) > 50) {
        goTo(diff > 0 ? current - 1 : current + 1);
        resetAutoplay();
      }
    }, { passive: true });

    goTo(0);

    /* Start autoplay on first user signal instead of page load. Rotating with no
       interaction makes slide 2's lazy image the LCP element (~9.5s in lab runs);
       gating keeps LCP on the eager slide-1 image. Real users trigger this with
       any scroll/mouse-move/touch, so the slideshow behaves the same for them. */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var armed = false;
    function arm() {
      if (armed) return;
      armed = true;
      startAutoplay();
    }
    window.addEventListener('scroll', arm, { once: true, passive: true });
    document.addEventListener('pointermove', arm, { once: true, passive: true });
    document.addEventListener('pointerdown', arm, { once: true, passive: true });
    document.addEventListener('touchstart', arm, { once: true, passive: true });
    document.addEventListener('keydown', arm, { once: true });
  });
})();
